import React from 'react';
import Gallery from '../components/Gallery';

const GalleryPage = () => {
  return (
    <div className="pt-20">
      <Gallery />
    </div>
  );
};

export default GalleryPage;